import Dashboard from "layouts/dashboard";
import Maintenance from "layouts/maintenance";
import Vendors from "layouts/vendor-directory";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SiteMap from "layouts/sitemaps";
import Local_Link from "layouts/local_link";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// import Units from "layouts/units";
import Calendar from "layouts/Calendar";
import Library from "layouts/library";
import Reservations from "layouts/reservations";
import PetRegistry from "layouts/petregistry";
import EventLog from "layouts/eventlog";
import Instructions from "layouts/instructions";
import Incidents from "layouts/incident";
import Resident_Directory from "layouts/resident_directory";
import searchRequests from "layouts/searchRequests";
import Email from "layouts/email";
import Public_Display from "layouts/public_display"
import BuildingDirectory from "layouts/building_directory"
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';


const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "unit",
  //   route: "/concierge/dashboard",
  //   activePaths: ["/concierge/dashboard"],
  //   icon: <SpaceDashboardIcon size="10px" />,
  //   noCollapse: true,
  //   children: []
  // },
  {
    type: "collapse",
    name: "Property",
    key: "unit",
    route: "/concierge/unit",
    activePaths: ["/concierge/unit", "/concierge/residents", "/concierge/properties"],
    icon: <Shop size="12px" />,
    component: <SiteMap />,
    noCollapse: true,
    children: [],
  },

  // {
  //   type: "collapse",
  //   name: "Manage",
  //   key: "manage",
  //   route: "/concierge/manage",
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Units/Occupants",
  //       key: "units-occupants",
  //       route: "/concierge/unit-occupants",
  //       icon: <Office size="12px" />,
  //       component: <Resident_Directory />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/concierge/calendar",
  //       icon: <CalendarMonthIcon fontSize="small" />,
  //       component: <Calendar />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Library",
  //       key: "library",
  //       route: "/concierge/library",
  //       icon: <Document size="12px" />,
  //       component: <Library />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Reservations",
  //       key: "reservations",
  //       route: "/concierge/reservations",
  //       icon: <Cube size="12px" />,
  //       component: <Reservations />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Pet Registry",
  //       key: "pet-registry",
  //       route: "/concierge/pet-registry",
  //       icon: <Settings size="12px" />,
  //       component: <PetRegistry />,
  //       noCollapse: true,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Front Desk",
  //   key: "front-desk",
  //   route: "/concierge/front-desk",
  //   activePaths: ["/concierge/front-desk", "/concierge/residents", "/concierge/properties"],
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: true,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Event Log",
  //       key: "event-log",
  //       route: "/concierge/event-log",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <EventLog />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Instructions",
  //       key: "instructions",
  //       route: "/concierge/instructions",
  //       icon: <Settings size="12px" />,
  //       component: <PetRegistry />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Incidents",
  //       key: "incidents",
  //       route: "/concierge/incidents",
  //       icon: <Settings size="12px" />,
  //       component: <PetRegistry />,
  //       noCollapse: true,
  //     },
  // ],
  // },

  // {
  //   type: "collapse",
  //   name: "Maintenance",
  //   key: "maintenance",
  //   route: "/concierge/maintenance",
  //   activePaths: ["/concierge/maintenance"],
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: true,
  //   children: [
  //     {
  //       type: "item",
  //       name: "New Request",
  //       key: "new-request",
  //       route: "/concierge/new-request",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Maintenance />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Search Requests",
  //       key: "search-requests",
  //       route: "/concierge/search-requests",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <searchRequests />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Vendor Directory",
  //       key: "vendor-directory",
  //       route: "/concierge/vendor-directory",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Vendors />,
  //       noCollapse: true,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Communicate",
  //   key: "communicate",
  //   route: "/concierge/communicate",
  //   activePaths: ["/concierge/communicate", "/concierge/residents", "/concierge/properties"],
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: true,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Send Email",
  //       key: "send-email",
  //       route: "/concierge/send-email",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Maintenance />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Library",
  //       key: "library",
  //       route: "/concierge/library",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Library />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Public Display",
  //       key: "public-display",
  //       route: "/concierge/public-display",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Public_Display />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Resident Directory",
  //       key: "resident-directory",
  //       route: "/concierge/resident-directory",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Resident_Directory />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Building Directory",
  //       key: "building-directory",
  //       route: "/concierge/building-directory",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <BuildingDirectory />,
  //       noCollapse: true,
  //     },
      
  //   ],
  // },
];

export default routes;
